import { FormBuilder, FormGroup } from '@angular/forms';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { QuestionMasterModel } from 'src/app/Models/QuestionMaster';
import { QuestionListComponent } from '../question-list/question-list.component';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
//import { number } from 'ngx-custom-validators/src/app/number/validator';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { AddEditFlashManagementService } from '../question-add-edit/services/add-edit.flash-management.service';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import { IFlashcard } from '../question-add-edit/interface/falshcard.interface';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FlashcardAssignModalComponent } from '../question-add-edit/flashcard-assign-modal/flashcard-assign-modal.component';
import { ShufflingFlashcardComponent } from '../question-add-edit/shuffling-flashcard/shuffling-flashcard.component';
import { FlashcardListModalComponent } from '../flashcard-list-modal/flashcard-list-modal.component';
import { FlashCardManagementService } from 'src/app/Services/flashcard-management.service';
import { takeUntil } from 'rxjs/operators';
declare const $: any;

@Component({
  selector: 'app-fa-question-master',
  templateUrl: './question-master.component.html',
  styleUrls: ['./question-master.component.css'],
})
export class QuestionMasterComponent implements OnInit, AfterViewInit {
  posts: any;
  QuestionMaster: FormGroup;
  QuestionMasterModel: QuestionMasterModel;
  DisableNextButton: boolean = false;
  myScriptElement: HTMLScriptElement;
  //EditQuestion:Subject<any> = new Subject();
  @Input() MajorTopic: MajorTopic[] = [];
  SearchQuestionID: any;
  headerName: string;
  currentPath: string | undefined;
  //@Output() EditQuestion1: EventEmitter<any> = new EventEmitter<any>();
  elements: any = [];
  flashCardModalRef: NgbModalRef | null = null;
  courseID: number |  null;
  currentRoute: string;
   private destroy$ = new Subject<void>();

  constructor(
    private SpinnerService: NgxSpinnerService,
    public datepipe: DatePipe,
    private toastr: ToastrService,
    public service: QuestionManagementService,
    private fb: FormBuilder,
    public Activeroute: ActivatedRoute,
    private readonly addEditFlashManagementService: AddEditFlashManagementService,
    private modalService: NgbModal,
    public flashcardService: FlashCardManagementService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  @ViewChild('childComponent') child: QuestionListComponent;
  // private questionlistcomponent = {} as QuestionListComponent;
  enableedit: boolean = true;
  Editsubjectflag = false;
  Addnewsubject = true;
  QuestionListflag: boolean = false;
  AddQuestionflag: boolean = false;
  ScreenName1: string;

  InitializeForm() {
    this.QuestionMaster = this.fb.group({
      Keywordsearch: [],
      CreatedBy: [],
      ApprovedBy: [],
      StartDate: [],
      EndDate: [],
    });
  }
  ngOnInit() {
    this.getkeyword();
    this.getCreatedBy();
    this.getApprovedBy();
    this.getCode();
    this.InitializeForm();
    this.getQuestionStatusType();
    this.currentPath = this.Activeroute.snapshot.routeConfig?.path;
    this.ScreenName1 =
      this.Activeroute.snapshot.paramMap.get('ScreenName') || '{}';

          this.route.url.pipe(takeUntil(this.destroy$)).subscribe((event) => {
            const routeSegments = event.map(seg => seg.path).join('/');
            this.currentRoute = '/' + routeSegments;
          });

    this.questionstatustype = null;
    this.QuestionKeyword1 = null;
    this.selectOperator = null;
    this.QuestionKeyword2 = null;
    this.OwnQuestionInd = false;
    this.getQuestionByIDlist = null;
    this.SearchQuestionID = null;
    this.Descriptioncount();

    // Getting Route params
    this.Activeroute.queryParams.subscribe((params) => {
      if (params?.c_id) {
        this.courseID = +params.c_id;
        this.getsubject(null, null);
        this.MajorTopic=[];
        this.selectedsubject=null
      }else{
        if(this.selectedsubject){
        this.RefreshActivity()
        }else{
       this.getsubject(null, null);
      }
      this.courseID = null
    }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  courseCleared(event:any){
    this.courseID = null
  }

  HeaderName() {
    try {
      switch (this.ScreenName1) {
        case 'SUBJECT BREAKDOWN':
          if (this.currentPath?.includes('/add/edit')) {
            return (this.headerName = 'Add/Edit Flash Card');
          } else {
            return (this.headerName = 'All Flash Card');
          }
        case 'WIP':
          return (this.headerName = 'WIP Flash Card');
        case 'Approved':
          return (this.headerName = 'Approved Flash Card');
        case 'Defer':
          return (this.headerName = 'Deferred  Flash Card');
        case 'Rejected':
          return (this.headerName = 'Rejected Flash Card');
        case 'Rework':
          return (this.headerName = 'Rework Flash Card');
        case 'Submitted':
          return (this.headerName = 'Submitted Flash Card');
        default:
          return (this.headerName = '');
      }
    } catch (error) {
      console.error('Error in HeaderName():', error);
      return (this.headerName = '');
    }
  }
  getHeader(): string {
    return 'Flash Card Management: ' + this.HeaderName();
  }
  ngAfterViewInit(): void {
    // $('#example').DataTable();
  }
  // #region Assign Flashcard
  AssignFlashCard(subjectId: number) {
    const modalRef = this.modalService.open(FlashcardAssignModalComponent, {
      backdrop: 'static',
      keyboard: false,
      scrollable: true,
      windowClass: 'custom-modal-width-2',
    });
    modalRef.componentInstance.openFlashCard.subscribe((data: any) => {
      this.openSelectedFlashCardEvent(data);
    });
    modalRef.componentInstance.clearedRoute.subscribe((data: any) => {
      this.courseID = null;
    });
    modalRef.componentInstance.currentRoute = this.currentRoute || '';
    modalRef.componentInstance.SubjectId = subjectId;
    modalRef.componentInstance.FlashcardId = null;
    modalRef.componentInstance.ScreenName = 'ASSIGN_FLASHCARD_TO_COURSE';
  }
  // #region Shuffle Question
  ShuffleQuestions(Mt: number) {
    const modalRef = this.modalService.open(ShufflingFlashcardComponent, {
      backdrop: 'static',
      keyboard: false,
      scrollable: false,
      windowClass: 'custom-modal-width-shuffle',
      backdropClass: 'light-blue-backdrop-shuffle',
    });
    modalRef.componentInstance.openFlashCard.subscribe((data: any) => {
      this.openSelectedFlashCardEvent(data);
    });
    modalRef.componentInstance.SubjectId = Mt;
    modalRef.componentInstance.QuestionId = null;
    modalRef.componentInstance.ScreenName = 'ASSIGN_FLASHCARD_TO_COURSE';
  }
  // #region FlashcardOpenList
  FlashCardListOpen(SubjectId: number): void {
    this.flashCardModalRef = this.modalService.open(
      FlashcardListModalComponent,
      {
        backdrop: 'static',
        keyboard: false,
        scrollable: true,
        windowClass: 'custom-modal-width-list',
      }
    );
    this.flashCardModalRef.componentInstance.openFlashCard.subscribe(
      (data: any) => {
        this.openSelectedFlashCardEvent(data);
      }
    );
    this.flashCardModalRef.componentInstance.SubjectId = SubjectId;
    this.flashCardModalRef.componentInstance.FlashcardId = null;
    this.flashCardModalRef.componentInstance.ScreenName = 'LIST_FLASHCARD';
  }
  InitialLoadFlag: string;
  SearchActivity() {
    // this.InitialLoadFlag='N';
    // this.getActivityhistory(this.selectedsubject);
    this.SearchQuestionModel();
    this.getQuestionByIDlist = null;
    this.SearchQuestionID = null;
  }

  Searchmodelpopup: boolean;
  SearchQuestionModel() {
    this.Searchmodelpopup = !this.Searchmodelpopup;
    this.Clear();
  }

  filtermodelpopup: boolean;
  FilterModelpopup() {
    this.filtermodelpopup = !this.filtermodelpopup;
    if (!this.Searchmodelpopup) {
      this.SearchQuestionModel();
    }
  }

  RefreshActivity() {
    this.getQuestionByIDlist = null;
    this.SearchQuestionID = null;
    let data = {
      target: {
        value: this.service.SelectSubject,
      },
    };
    this.selectsubject(data);
  }

  getvalue: any;
  ActivityHistorylist: any;
  FromDate: string | null;
  ToDate: string | null;
  QuestionStatus: string | null;
  QuestionKeyword1: string | null;
  selectOperator: string | null;
  QuestionKeyword2: string | null;
  OwnQuestionInd: boolean = false;
  operator = [
    {
      Code: 'AND',
      Description: 'AND',
    },
    {
      Code: 'OR',
      Description: 'OR',
    },
    {
      Code: null,
      Description: '',
    },
  ];
  getActivityhistory(data: any) {
    if (!this.questionstatustype) {
      this.QuestionStatus = null;
    }

    let list: any = {
      Subject_Id: data,
      From_Date: this.datepipe.transform(this.FromDate, 'MM/dd/yyyy'),
      To_Date: this.datepipe.transform(this.ToDate, 'MM/dd/yyyy'),
      Question_Status_Type_Code: this.questionstatustype,
      InitialLoadInd: this.InitialLoadFlag,
      QuestionKeyword1: this.QuestionKeyword1,
      Operator: this.selectOperator,
      QuestionKeyword2: this.QuestionKeyword2,
      OwnQuestionInd: this.OwnQuestionInd,
    };

    // this.SpinnerService.show();
    this.service.GetQuestionActivityHistory(list).subscribe(
      (i: any) => {
        this.getvalue = i;

        // if(this.getvalue.Data.length>0){
        this.ActivityHistorylist = this.getvalue.Data;

        // this.SpinnerService.hide();
        // }
        // else{
        //   this.toastr.warning('No Record');
        // }
      },
      (error: any) => {
        console.log(error);
        // this.SpinnerService.hide();
      }
    );
  }

  ActivityHisotrypopupflag: boolean;
  ViewActivityHistory() {
    this.ActivityHisotrypopupflag = !this.ActivityHisotrypopupflag;
    // if(this.ActivityHisotrypopupflag){
    //  this.getActivityhistory(this.service.SelectSubject);
    // }
    this.getQuestionByIDlist = null;
    this.SearchQuestionID = null;
  }

  Questionlistpopupflag: boolean;
  ViewQuestionlistpopupflag() {
    this.Questionlistpopupflag = !this.Questionlistpopupflag;
  }

  getkeywordlist: any;
  getkeyword() {
    // this.SpinnerService.show();
    this.service.GetCode({ Tablename: 'SEARCH_MATCH_TYPE' }).subscribe(
      (i: any) => {
        this.getkeywordlist = i;
        // this.SpinnerService.hide();
        // }).catch((e:any)=>{
        //   this.getkeywordlist=null;
        // });
      },
      (error) => {
        console.log(error);
        // this.SpinnerService.hide();
      }
    );
  }

  ClickOwnQuestionInd() {
    this.OwnQuestionInd = !this.OwnQuestionInd;
  }

  data: any;
  getApprovedby: any;
  getApprovedBy() {
    this.data = {
      PowerUserStatusTypeCode: 'SME',
      SubjectID: null,
      ScreenName: 'Question',
    };
    // this.SpinnerService.show();
    this.service.GetPowerUserList(this.data).subscribe(
      (i: any) => {
        this.getApprovedby = i;
        console.log(this.getApprovedby);
        // this.SpinnerService.hide();
        // }).catch((e:any)=>{
        //   this.getApprovedby=null;
        // });
      },
      (error) => {
        console.log(error);
        // this.SpinnerService.hide();
      }
    );
  }
  getdata: any;
  getCreatedby: any;
  getCreatedBy() {
    this.getdata = {
      PowerUserStatusTypeCode: 'SME',
      SubjectID: null,
      ScreenName: 'Question',
    };
    // this.SpinnerService.show();
    this.service.GetPowerUserList(this.getdata).subscribe(
      (i: any) => {
        this.getCreatedby = i;
        console.log(this.getCreatedby);
        // this.SpinnerService.hide();
        // }).catch((e:any)=>{
        //   this.getCreatedby=null;
        // });
      },
      (error) => {
        console.log(error);
        // this.SpinnerService.hide();
      }
    );
  }

  subject: any;
  getsubject(data: any, d: any) {
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data.ID);

    }
    let list: any = {};
    list['currentNodeID'] = ID;
    list['screenName'] = 'SUBJECT BREAKDOWN';
    list['childRecordStatus'] = 'ALL';
    list['CalledFrom'] = this.courseID ? `FLASHCARD@${this.courseID}` : `FLASHCARD`;


    // let list: any = {};
    // if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='SUBJECT BREAKDOWN'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'SUBJECT BREAKDOWN';
    //   list["childRecordStatus"] = 'ALL';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='WIP'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'WIP';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Approved'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'Approved';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Defer'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'Defer';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Rejected'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'Rejected';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Rework'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'Rework';
    // }
    // else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Submitted'){
    //   //let list: any = {};
    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'QUESTION';
    //   list["childRecordStatus"] = 'Submitted';
    // }
    // else{

    //   list["currentNodeID"] = ID;
    //   list["screenName"] = 'SUBJECT BREAKDOWN';
    //   list["childRecordStatus"] = 'ALL';
    // }
    // this.SpinnerService.show();
    this.service.getSubjectTree(list).subscribe(
      (i: any) => {
        this.subject = i;
        console.log(this.subject);
        // this.SpinnerService.hide();
        // }).catch((e:any)=>{
        //   this.subject=null;
        // }
        // )
      },
      (error) => {
        console.log(error);
        // this.SpinnerService.hide();
      }
    );
  }

  parentid: any;
  breadcrumbID: any = [];
  Dynamic: any;
  Refresh: any;
  Descriptionvalue: any;
  question: any;
  ScreenName: any;

  getsubjectData(
    data: any,
    name: any,
    M: any,
    C?: any,
    SC1?: any,
    SC2?: any,
    SC3?: any,
    SC4?: any,
    SC5?: any
  ) {
    // this.Refresh = {
    //   dataID:data,
    //   name:name,
    //   M:M,
    //   C:C,
    //   SC1:SC1,
    //   SC2:SC2,
    //   SC3:SC3,
    //   SC4:SC4,
    //   SC5:SC5
    // }
    // this.addNewConcept(data,name,M,C,SC1,SC2,SC3,SC4,SC5);
    let majortopicsarr: any = [];
    if (this.MajorTopic != null) {
      majortopicsarr = this.MajorTopic;
    }
    this.getsubjectId(data);
    //this.getBreadcrumbDetails(data);
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data);
    }
    this.ScreenName = this.Activeroute.snapshot.paramMap.get('ScreenName');
    let list: any = {};
    if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') ==
      'SUBJECT BREAKDOWN'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'SUBJECT BREAKDOWN';
      list['childRecordStatus'] = 'ALL';
      list['CalledFrom'] = this.courseID ? `FLASHCARD@${this.courseID}` : `FLASHCARD`;

    } else if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'WIP') {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'FLASHCARD';
      list['childRecordStatus'] = 'WIP';
      list['CalledFrom'] = this.courseID ? `FLASHCARD@${this.courseID}` : `FLASHCARD`;

    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Approved'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'FLASHCARD';
      list['childRecordStatus'] = 'Approved';
      list['CalledFrom'] = this.courseID ? `FLASHCARD@${this.courseID}` : `FLASHCARD`;

    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Defer'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'FLASHCARD';
      list['childRecordStatus'] = 'Defer';
      list['CalledFrom'] = this.courseID ? `FLASHCARD@${this.courseID}` : `FLASHCARD`;

    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rejected'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'FLASHCARD';
      list['childRecordStatus'] = 'Rejected';
      list['CalledFrom'] = this.courseID ? `FLASHCARD@${this.courseID}` : `FLASHCARD`;

    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rework'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'FLASHCARD';
      list['childRecordStatus'] = 'Rework';
      list['CalledFrom'] = this.courseID ? `FLASHCARD@${this.courseID}` : `FLASHCARD`;

    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Submitted'
    ) {
      //let list: any = {};
      list['currentNodeID'] = ID;
      list['screenName'] = 'FLASHCARD';
      list['childRecordStatus'] = 'Submitted';
      list['CalledFrom'] = null;
    } else {
      list['currentNodeID'] = ID;
      list['screenName'] = 'SUBJECT BREAKDOWN';
      list['childRecordStatus'] = 'ALL';
      list['CalledFrom'] = this.courseID ? `FLASHCARD@${this.courseID}` : `FLASHCARD`;

    }
    this.service.getSubjectTree(list).subscribe(
      (i: any) => {
        if (name == 'MT') {
          this.MajorTopic = i;

          this.subject.forEach((i: { ID: any }) => {
            if (Number(i.ID) === Number(ID)) {
            }
          });
        } else if (name == 'C') {
          if (this.MajorTopic[M].Data !== null) this.MajorTopic[M].Data = null;
          else {
            this.MajorTopic[M].Data = i;
          }
        } else if (name == 'SC1') {
          if (this.MajorTopic[M].Data[C].Data !== null)
            this.MajorTopic[M].Data[C].Data = null;
          else {
            this.MajorTopic[M].Data[C].Data = i;
          }
        } else if (name == 'SC2') {
          if (this.MajorTopic[M].Data[C].Data[SC1].Data !== null)
            this.MajorTopic[M].Data[C].Data[SC1].Data = null;
          else {
            this.MajorTopic[M].Data[C].Data[SC1].Data = i;
          }
        } else if (name == 'SC3') {
          if (this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data !== null)
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data = null;
          else {
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data = i;
          }
        } else if (name == 'SC4') {
          if (
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data !==
            null
          )
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data =
              null;
          else {
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data = i;
          }
        } else if (name == 'SC5') {
          if (
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4]
              .Data !== null
          )
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[
              SC4
            ].Data = null;
          else {
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[
              SC4
            ].Data = i;
          }
        } else if (name == 'SC6') {
          if (
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[SC4]
              .Data[SC5].Data !== null
          )
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[
              SC4
            ].Data[SC5].Data = null;
          else {
            this.MajorTopic[M].Data[C].Data[SC1].Data[SC2].Data[SC3].Data[
              SC4
            ].Data[SC5].Data = i;
          }
        }
        console.log(this.MajorTopic, 'check');
        // this.SpinnerService.hide();
        //   }).catch((e:any)=>{
        //   this.subject=null;
        // }
        // )
      },
      (error) => {
        console.log(error);
        this.SpinnerService.hide();
      }
    );
  }



  statusvalidate: any;
  DefaultStatus: any;
  subjectById: any;
  getsubjectId(data: any) {
    let ID: Number = 0;
    try {
      if (data > 0 || data == null) {
        ID = Number(data);
      } else if (Number(data.ID) > 0) {
        ID = Number(data.ID);
      }
    } catch {}
    //  this.SpinnerService.show();
    this.service.getsubjectById({ CurrentNodeSubjectID: ID }).subscribe(
      (i: any) => {
        this.subjectById = i;
        // if (this.AddQuestionflag) {
        //   this.QuestionTemplateType();
        // }
        // this.SpinnerService.hide();

        // }).catch((e:any)=>{
        //   this.subjectById=null;
        // }
        // )
      },
      (error) => {
        console.log(error);
        this.SpinnerService.hide();
      }
    );
  }

  selectedvalue: Number;
  selectedkey: string = '';
  subjectID: any;
  count: Number;
  currentIDselected: Number;
  OnSelect(Value?: Number, d?: any, childnodeexist?: string) {
    //  console.clear();
    // this.count=1;
    this.subjectID = Value;
    // if(this.currentIDselected == Value){
    // //this.QuestionList(Value);

    //  this.count=Number(this.count) + 1;
    // }else{
    //  this.count=1;
    //  this.currentIDselected=Value;
    // }

    // if(this.count==1){
    // console.log(childnodeexist);
    //     if(childnodeexist === "N" || childnodeexist === 'N'){
    //     this.QuestionList(Value);
    //   }
    // }

    if (Value == null) {
      return;
    } else if (Number(Value) > 0) {
      this.selectedvalue = Number(Value);
      this.selectedkey = d;
    } else {
      this.selectedvalue = 0;
      this.selectedkey = d;
    }
  }

  selectedlist: any;
  selectedsubjectquestion: any;
  getQuestionlist(Value?: Number) {
    if (Value != null) {
      this.selectedsubjectquestion = Value;
      // this.getsubjectId(Value);
      this.openFlashcardList(Value);
      // this.QuestionList(Value);
      // this.QuestionBySubject(Value);
    }
  }

  openFlashcardList(data: any) {
    let ID: Number = 0;
    try {
      if (data > 0 || data == null) {
        ID = Number(data);
      } else if (Number(data.ID) > 0) {
        ID = Number(data.ID);
      }
    } catch {}
    //  this.SpinnerService.show();
    this.service.getsubjectById({ CurrentNodeSubjectID: ID }).subscribe(
      (i: any) => {
        this.subjectById = i;
        this.FlashCardListOpen(this.subjectById.Subject_Id);
        // this.Questionlistpopupflag = true;
      },
      (error) => {
        console.log(error);
        this.SpinnerService.hide();
      }
    );
  }

  questionsubjectresponse: any;
  response: any;
  QuestionBySubject(data: any) {
    // this.SpinnerService.show();
    this.service.GetQuestionSubject({ SubjectID: Number(data) }).subscribe(
      (i: any) => {
        this.response = i;
        this.questionsubjectresponse = this.response.SubjectExistsInd;
        // this.SpinnerService.hide();

        console.log(this.questionsubjectresponse);
        //  }).catch((e:any)=>{
        //    this.Questionlistresponse=e;
        //  }
        //  )
      },
      (error) => {
        console.log(error);
        this.SpinnerService.hide();
      }
    );
  }

  OnFocus(Value?: Number, d?: any) {
    this.QuestionList(Value);
  }

  checkToEnableAddEdit() {
    if (this.Addnewsubject === true) {
      this.enableedit = true;
    } else if (this.Editsubjectflag === true) {
      this.enableedit = true;
    } else {
      this.enableedit = false;
    }
  }

  mouseoverevent(ID: Number, P1: string, P2?: string): boolean {
    if (
      this.enableedit == true &&
      Number(this.selectedvalue) == ID &&
      (P1 === this.selectedkey || this.selectedkey == P2) &&
      P2 != null
    ) {
      return true;
    } else if (
      this.enableedit == true &&
      Number(this.selectedvalue) == ID &&
      P1 === this.selectedkey
    ) {
      return true;
    } else {
      return false;
    }
  }

  getcodes: any;
  getCode() {
    // this.SpinnerService.show();
    this.service.GetCode({ Tablename: 'SUBJECT_LEVEL_TYPE' }).subscribe(
      (i: any) => {
        this.getcodes = i;
        // this.SpinnerService.hide();

        // }).catch((e:any)=>{
        //   this.getcodes=null;
        // });
      },
      (error) => {
        console.log(error);
        this.SpinnerService.hide();
      }
    );
  }

  RefreshEditQuestion(data: any) {
    this.QuestionList(data);

    if (this.ActivityHistorylist) {
      this.getActivityhistory(data);
    }
  }

  Questionlistresponse: any;
  Search: any;
  QuestionList(data: any) {
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data);
    }
    let list: any = {};
    if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') ==
      'SUBJECT BREAKDOWN'
    ) {
      //let list: any = {};
      list['SubjectID'] = ID;
      list['QuestionStatusTypeCode'] = 'WIP';
    } else if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'WIP') {
      //let list: any = {};
      list['SubjectID'] = ID;
      list['QuestionStatusTypeCode'] = 'WIP';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Approved'
    ) {
      //let list: any = {};
      list['SubjectID'] = ID;
      list['QuestionStatusTypeCode'] = 'Approved';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Defer'
    ) {
      //let list: any = {};
      list['SubjectID'] = ID;
      list['QuestionStatusTypeCode'] = 'Defer';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rejected'
    ) {
      //let list: any = {};
      list['SubjectID'] = ID;
      list['QuestionStatusTypeCode'] = 'Rejected';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rework'
    ) {
      //let list: any = {};
      list['SubjectID'] = ID;
      list['QuestionStatusTypeCode'] = 'Rework';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Submitted'
    ) {
      //let list: any = {};
      list['SubjectID'] = ID;
      list['QuestionStatusTypeCode'] = 'Submitted';
    } else {
      list['SubjectID'] = ID;
      list['QuestionStatusTypeCode'] = null;
    }
    // this.SpinnerService.show();
    this.service.GetQuestionList(list).subscribe(
      (i: any) => {
        this.Search = i;
        this.Questionlistresponse = this.Search.SubjectExistsInd;
        this.selectedlist = ID;
        this.ViewQuestionlistpopupflag();
        // this.SpinnerService.hide();
        console.log(this.Questionlistresponse);
        //  }).catch((e:any)=>{
        //    this.Questionlistresponse=e;
        //  }
        //  )
      },
      (error) => {
        console.log(error);
        this.SpinnerService.hide();
      }
    );
  }

  selectQuestionTemplate: boolean;
  QuestionTemplateType() {
    this.selectQuestionTemplate = !this.selectQuestionTemplate;
    if (this.AddQuestionflag) {
      this.AddQuestionflag = false;
    }
  }

  AddQuestion(data: any) {
    let ID: Number = 0;
    try {
      if (data > 0 || data == null) {
        ID = Number(data);
      } else if (Number(data.ID) > 0) {
        ID = Number(data.ID);
      }
    } catch {}
    //  this.SpinnerService.show();
    this.service.getsubjectById({ CurrentNodeSubjectID: ID }).subscribe(
      (i: any) => {
        this.subjectById = i;

        this.NextButtonflag = true;
      },
      (error) => {
        console.log(error);
        this.SpinnerService.hide();
      }
    );
  }
  selectedQuestionList: any;
  ClickNextButton(data: any) {
    this.selectedQuestionList = data;
    this.selectedQuestionById = null;
    for (let item of this.selectedQuestionList) {
      if (item.checkedflag) {
        this.DisableNextButton = true;
      }
    }

    this.AddQuestionpopup();
  }

  selectedQuestionById: any;
  ClickQuestionBody(data: any) {
    this.selectedQuestionById = data;
    this.QuestionBody();
  }

  Answerflag: any;
  ClickAnswerChoice(data: any) {
    this.selectedQuestionById = data.QuestionById;
    this.Answerflag = data.Answerflag1;

    this.AnswerChoiceBody();
  }
  ClickAnswerChoiceNoteBody(data: any) {
    this.selectedQuestionById = data;
    this.AnswerChoiceNoteBody();
  }
  ClickAddsolutionHint(data: any) {
    this.selectedQuestionById = data;
    this.AddSolutionHint();
  }
  // ClickQuestionPreview(data:any){
  //   this.selectedQuestionById=data;
  //   this.QuestionPreview();
  // }
  ReturnQuestionpreview(data: any) {
    //this.getQuestionByID(this.selectedQuestionById[0].Question_ID);
    if (this.Questionpreviewpopupflag) {
      this.QuestionPreview();
    }
    this.AddQuestionpopup();
  }
  previewdetail: any;
  ClickQuestionPreview(data: any) {
    this.previewdetail = data;
    this.QuestionPreview();
  }
  Questionstatus: any;
  ClickQuestionstatus(data: any) {
    this.selectedQuestionById = data.Question;
    this.Questionstatus = data.Question_status;
    this.Questionreview();
  }

  NextButtonflag: boolean;
  AddQuestionpopup() {
    if (this.NextButtonflag && this.Questionlistresponse != null) {
      this.RefreshEditQuestion(this.subjectById.Subject_Id);
    }
    if (this.selectQuestionTemplate) {
      this.QuestionTemplateType();
    }
    if (this.QuestionBodyPopup) {
      this.QuestionBody();
    }
    if (this.AnswerChoicePopup) {
      this.redirect = false;
      this.AnswerChoiceBody();
    }
    if (this.AnswerChoiceNotePopup) {
      this.redirect = false;
      this.AnswerChoiceNoteBody();
    }
    if (this.EditAnswerChoiceNotePopup) {
      this.redirect = false;
      this.EditAnswerChoiceNoteBody();
    }
    if (this.Addsolutionhintpopup) {
      this.redirect = false;
      this.AddSolutionHint();
    }
    if (this.EditSolutionHintPopup) {
      this.redirect = false;
      this.EditSolutionHintBody();
    }
    if (this.Questionpreviewpopupflag) {
      this.redirect = false;
      this.QuestionPreview();
    }
    if (this.Questionreviewpopupflag) {
      this.redirect = false;
      this.Questionreview();
    }
    if (this.QuestionStatuspopupflag) {
      this.redirect = false;
      this.QuestionStatusPopup();
    }

    this.NextButtonflag = !this.NextButtonflag;
  }

  QuestionBodyPopup: boolean;
  QuestionBody() {
    if (this.NextButtonflag) {
      this.AddQuestionpopup();
    }
    this.QuestionBodyPopup = !this.QuestionBodyPopup;
  }

  AnswerChoicePopup: boolean;
  AnswerChoiceBody() {
    if (this.NextButtonflag) {
      this.AddQuestionpopup();
    }
    this.AnswerChoicePopup = !this.AnswerChoicePopup;
  }

  AnswerChoiceNotePopup: boolean;
  AnswerChoiceNoteBody() {
    if (this.NextButtonflag) {
      this.AddQuestionpopup();
    }
    this.AnswerChoiceNotePopup = !this.AnswerChoiceNotePopup;
  }

  EditAnswerChoiceNotePopup: boolean;
  EditAnswerChoiceNoteBody() {
    if (this.NextButtonflag) {
      this.AddQuestionpopup();
    }
    this.EditAnswerChoiceNotePopup = !this.EditAnswerChoiceNotePopup;
  }

  Addsolutionhintpopup: boolean;
  AddSolutionHint() {
    if (this.NextButtonflag) {
      this.AddQuestionpopup();
    }
    this.Addsolutionhintpopup = !this.Addsolutionhintpopup;
  }

  EditSolutionHintPopup: boolean;
  EditSolutionHintBody() {
    if (this.NextButtonflag) {
      this.AddQuestionpopup();
    }
    this.EditSolutionHintPopup = !this.EditSolutionHintPopup;
  }

  Questionpreviewpopupflag: boolean;
  QuestionPreview() {
    if (this.NextButtonflag) {
      this.AddQuestionpopup();
    }
    this.Questionpreviewpopupflag = !this.Questionpreviewpopupflag;
  }

  Questionreviewpopupflag: boolean;
  Questionreview() {
    if (this.NextButtonflag) {
      this.AddQuestionpopup();
    }
    this.Questionreviewpopupflag = !this.Questionreviewpopupflag;
  }

  EditAnswerNote(data: any) {
    this.selectedQuestionById = data;
    this.EditAnswerChoiceNoteBody();
  }

  EditSolutionHint(data: any) {
    this.selectedQuestionById = data;
    this.EditSolutionHintBody();
  }

  AddQuestionBodyclose(data: any) {
    this.AddQuestionpopup();
  }

  AddAnswerchoiceclose(data: any) {
    this.AddQuestionpopup();
  }
  AddAnswerchoiceNoteclose(data: any) {
    this.AddQuestionpopup();
  }
  EditAddAnswerchoiceNoteclose(data: any) {
    this.AddQuestionpopup();
  }

  AddSolutionHintclose(data: any) {
    this.AddQuestionpopup();
  }
  EditSolutionHintclose(data: any) {
    this.AddQuestionpopup();
  }

  AddQuestionHeaderClose(data: any) {
    // this.AddQuestionpopup();
  }

  Questionreviewclose(data: any) {
    if (this.Questionreviewpopupflag) {
      this.Questionreview();
    }
    this.getActivityhistory(this.subjectById.Subject_Id);
  }
  CloseEditQuestion1(data: any) {
    this.CloseEditQuestion(1);
  }
  CloseEditQuestion(data: any) {
    if (this.NextButtonflag) {
      this.AddQuestionpopup();
    }
    this.RefreshEditQuestion(this.subjectById.Subject_Id);
  }
  ReturnQuestionreviewclose(data: any) {
    this.AddQuestionpopup();
  }
  ReturnQuestionStatushistory(data: any) {
    this.AddQuestionpopup();
  }

  QuestionStatuspopupflag: boolean;
  QuestionStatusPopup() {
    if (this.NextButtonflag) {
      this.AddQuestionpopup();
    }
    this.QuestionStatuspopupflag = !this.QuestionStatuspopupflag;
  }

  ClickQuestionStatusPopup(data: any) {
    this.selectedQuestionById = data;
    this.QuestionStatusPopup();
  }
  selectedsubject: any;
  selectsubject(data: any) {
    this.service.SelectSubject = data.target.value;
    this.selectedsubject = data.target.value;
    this.FromDate = null;
    this.ToDate = null;
    this.InitialLoadFlag = 'Y';
    if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') ==
      'SUBJECT BREAKDOWN'
    ) {
      this.questionstatustype = null;
    } else if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'WIP') {
      this.questionstatustype = 'WIP';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Approved'
    ) {
      this.questionstatustype = 'Approved';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Defer'
    ) {
      this.questionstatustype = 'Defer';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rejected'
    ) {
      this.questionstatustype = 'Rejected';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rework'
    ) {
      this.questionstatustype = 'Rework';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Submitted'
    ) {
      this.questionstatustype = 'Submitted';
    } else {
      this.questionstatustype = null;
    }
    //this.questionstatustype=null;
    this.getsubjectData(data.target.value, 'MT', null);
    // this.getActivityhistory(data.target.value);
  }

  getquestionstatustype: any;
  questionstatustype: string | null = null;
  getQuestionStatusType() {
    // this.SpinnerService.show();
    this.service.GetCode({ Tablename: 'QUESTION_STATUS_TYPE' }).subscribe(
      (i: any) => {
        this.getquestionstatustype = i;
        // this.SpinnerService.hide();

        // }).catch((e:any)=>{
        //   this.getquestionstatustype=null;
        // });
      },
      (error) => {
        console.log(error);
        this.SpinnerService.hide();
      }
    );
  }
  ActivityHistoryflag: boolean = false;

  EditButton(data: any) {
    this.ActivityHistoryflag = true;
    //this.getsubjectId(data.Subject_Id);
    // this.SpinnerService.show();
    let subjectid;
    if (data.Subject_Id != null) {
      subjectid = data.Subject_Id;
    } else if (data.Subject_ID != null) {
      subjectid = data.Subject_ID;
    }
    this.service
      .getsubjectById({ CurrentNodeSubjectID: Number(subjectid) })
      .subscribe((i: any) => {
        this.subjectById = i;
        this.questionsubjectresponse = this.ActivityHistorylist;
        // this.child.EditQuestion(data);
        // this.SpinnerService.hide();
      });

    // this.questionlistcomponent.EditQuestion(data);
  }

  FilteredQuestionEditButton(data: any) {
    this.ActivityHistoryflag = true;
    //this.getsubjectId(data.Subject_Id);
    // this.SpinnerService.show();
    this.service
      .getsubjectById({ CurrentNodeSubjectID: Number(data.Subject_Id) })
      .subscribe((i: any) => {
        this.subjectById = i;
        this.questionsubjectresponse = this.getquestionFilterlist;
        // if(this.filtermodelpopup){
        //   this.FilterModelpopup();
        // }
        if (this.Searchmodelpopup) {
          this.SearchQuestionModel();
        }
        // this.child.EditQuestion(data);
        // this.SpinnerService.hide();
      });

    // this.questionlistcomponent.EditQuestion(data);
  }

  NewConceptModel: any;
  selectedQuestionvalue: number;

  addNewConcept(
    data: any,
    name: string,
    M: number,
    C?: number,
    SC1?: number,
    SC2?: number,
    SC3?: number,
    SC4?: number,
    SC5?: number,
    SC6?: number
  ) {
    for (let item of this.getcodes) {
      if (item.Code == 'SCL1') item.Code = 'SC1';
      else if (item.Code == 'SCL2') item.Code = 'SC2';
      else if (item.Code == 'SCL3') item.Code = 'SC3';
      else if (item.Code == 'SCL4') item.Code = 'SC4';
      else if (item.Code == 'SCL5') item.Code = 'SC5';
      else if (item.Code == 'SCL6') item.Code = 'SC6';
      else item.Code;
      if (item.Code == name) {
        this.Descriptionvalue = item.Description;
      }
    }
    this.InitializeForm();
    this.Editsubjectflag = false;
    this.Addnewsubject = true;
    this.QuestionListflag = true;
    this.selectedQuestionvalue = Number(data.ID);
    //this.QuestionList(data.ID);
  }

  //#region show/hidden search
  ShowSearch: boolean = false;
  showsearch(): void {
    this.ShowSearch = !this.ShowSearch;
  }
  //#endregion
  Questionlist: any;
  getQuestionByIDlist: any;
  SearchQuestionInd: boolean = false;
  Questiondata: any;
  SearchQuestion() {
    // this.ActivityHistorylist.forEach((element: { Question_Id: any; }) => {
    //   if(element.Question_Id==this.SearchQuestionID){
    //     this.EditButton(element);
    //     return;
    //   }
    //   else{
    //     this.toastr.warning("Invalid Question No");
    //   }

    //  });
    if (this.SearchQuestionID) {
      // this.SpinnerService.show();
      // let Slicequestion=this.SearchQuestionID.slice(0,4);
      // if(this.subjectById.Subject_Short_Code==Slicequestion){

      this.service
        .GetQuestionByID({ QuestionID: this.SearchQuestionID })
        .subscribe(
          (i: any) => {
            this.Questionlist = i;
            this.getQuestionByIDlist = this.Questionlist.result;
            // this.SpinnerService.hide();
            this.service.QuestionByIDlist = this.getQuestionByIDlist;
            if (
              this.getQuestionByIDlist != undefined &&
              this.getQuestionByIDlist != null
            ) {
              if (this.getQuestionByIDlist.length > 0) {
                if (this.getQuestionByIDlist[0].Question_ID != null) {
                  this.Questiondata = this.getQuestionByIDlist[0];
                  // if(Question_Id==this.SearchQuestionID){
                  //this.EditButton(this.getQuestionByIDlist[0]);
                  // this.SpinnerService.show();
                  let subjectid;
                  if (this.getQuestionByIDlist[0].Subject_Id != null) {
                    subjectid = this.getQuestionByIDlist[0].Subject_Id;
                  } else if (this.getQuestionByIDlist[0].Subject_ID != null) {
                    subjectid = this.getQuestionByIDlist[0].Subject_ID;
                  }

                  this.service
                    .getsubjectById({ CurrentNodeSubjectID: Number(subjectid) })
                    .subscribe(
                      (i: any) => {
                        this.subjectById = i;
                        this.service
                          .GetQuestionSubject({
                            SubjectID: Number(this.subjectById.Subject_Id),
                          })
                          .subscribe(
                            (i: any) => {
                              this.response = i;
                              this.questionsubjectresponse =
                                this.response.SubjectExistsInd;
                              // this.child.EditQuestion(
                              //   this.getQuestionByIDlist[0]
                              // );
                            },
                            (error) => {
                              console.log(error);
                            }
                          );

                        //  }).catch((e:any)=>{
                        //    this.Questionlistresponse=e;
                        //  }
                        //  )
                      },
                      (error) => {
                        console.log(error);
                      }
                    );

                  //}
                } else {
                  this.toastr.warning('Question Number does not exist');
                }
              } else {
                this.toastr.warning('Question Number does not exist');
              }
            } else {
              this.toastr.warning('Question Number does not exist');
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      this.toastr.warning('Enter Question Number');
    }

    // else{
    //   this.toastr.warning("This Question Not in"+this.service.SelectSubject);
    // }
  }

  //  error:any={isError:false,errorMessage:''};
  // compareEndDates(){

  //   if(new Date(this.ToDate)<new Date(this.FromDate)){
  //      this.error={isError:true,errorMessage:'End Date cant before start date'};
  //   }
  //   else{
  //     this.error={isError:false,errorMessage:''};
  //   }
  //  }

  //  error1:any={isError:false,errorMessage:''};
  //  compareStartDates(){
  //    if(new Date(this.FromDate)<new Date(this.ToDate)){
  //       this.error1={isError:true,errorMessage:'Start Date cant before current date'};
  //    }
  //    else{
  //      this.error1={isError:false,errorMessage:''};
  //    }
  //    this.compareEndDates();

  //   }
  Clear() {
    this.FromDate = null;
    this.ToDate = null;
    this.InitialLoadFlag = 'N';
    this.questionstatustype = null;
    this.QuestionKeyword1 = null;
    this.selectOperator = null;
    this.QuestionKeyword2 = null;
    this.OwnQuestionInd = false;
    this.error = { isError: false, errorMessage: '' };
    this.Descriptionvaluelength = 0;
  }
  FilterQuestion() {
    this.getActivityhistoryquestion(this.selectedsubject);
  }

  getquestionFilterlist: any;
  getquestionFilterResponse: any;
  OwnQuestionIndflag: string;
  finalkeyword1: string;
  getActivityhistoryquestion(data: any) {
    if (!this.questionstatustype) {
      this.QuestionStatus = null;
    }
    if (!this.selectOperator) {
      this.selectOperator = null;
    }
    if (this.OwnQuestionInd) {
      this.OwnQuestionIndflag = 'Y';
    } else {
      this.OwnQuestionIndflag = 'N';
    }
    if (this.QuestionKeyword1) {
      const noSpecialChars = this.QuestionKeyword1.replace(
        /[^a-zA-Z0-9 ]/g,
        ' '
      );
      // const nounderscore = noSpecialChars.replace(/[_]/g, ' ');
      const out = noSpecialChars.replace(/\s/g, '_');
      const out1 = out.replace(/_+/g, '_');
      const name = out1.substr(0, out1.lastIndexOf('_'));

      const first10 = name.slice(0, 100);
      // const noSpecialChars = this.QuestionKeyword1.replace(/[^a-zA-Z0-9 ]/g, '');
      // const out = noSpecialChars.replace(/\s/g, "");
      //this.QuestionKeyword1=first10;
      this.finalkeyword1 = first10;
    } else {
      this.QuestionKeyword1 = null;
    }
    if (this.QuestionKeyword2) {
      const noSpecialChars = this.QuestionKeyword2.replace(
        /[^a-zA-Z0-9 ]/g,
        ' '
      );
      // const nounderscore = noSpecialChars.replace(/[_]/g, ' ');
      const out = noSpecialChars.replace(/\s/g, '_');
      const out1 = out.replace(/_+/g, '_');
      const name = out1.substr(0, out1.lastIndexOf('_'));

      const first100 = name.slice(0, 100);
      //this.finalkeyword2=first100;
      //this.QuestionKeyword2=first100;
    } else {
      this.QuestionKeyword2 = null;
    }

    let list: any = {
      Subject_Id: data,
      From_Date: this.datepipe.transform(this.FromDate, 'MM/dd/yyyy'),
      To_Date: this.datepipe.transform(this.ToDate, 'MM/dd/yyyy'),
      Question_Status_Type_Code: this.questionstatustype,
      InitialLoadInd: 'N',
      QuestionKeyword1: this.finalkeyword1,
      Operator: this.selectOperator,
      QuestionKeyword2: this.QuestionKeyword2,
      OwnQuestionInd: this.OwnQuestionIndflag,
    };

    // this.SpinnerService.show();

    this.service.GetQuestionActivityHistory(list).subscribe(
      (i: any) => {
        this.getquestionFilterResponse = i;

        if (this.getquestionFilterResponse.Message == 'Success') {
          this.getquestionFilterlist = this.getquestionFilterResponse.Data;
          console.log(this.getquestionFilterlist);

          if (this.getquestionFilterlist.length > 0) {
            if (this.Searchmodelpopup) {
              this.SearchQuestionModel();
            }
            this.FilterModelpopup();
          } else {
            this.toastr.warning('Question does not exist');
          }
        } else {
          this.toastr.error(this.getquestionFilterResponse.Message);
        }
        // this.SpinnerService.hide();
      },
      (error: any) => {
        console.log(error);
        this.SpinnerService.hide();
      }
    );
  }

  Descriptionvaluelength: any;
  DescriptionMaxlength: any;
  error: any = { isError: false, errorMessage: '' };
  Descriptioncount() {
    this.DescriptionMaxlength = 100;
    if (this.QuestionKeyword1 != '' && this.QuestionKeyword1 != null) {
      if (this.QuestionKeyword1.length > 0) {
        this.Descriptionvaluelength = this.QuestionKeyword1.length;
        this.FromDate = null;
        this.ToDate = null;
        if (this.QuestionKeyword1.length != 100) {
          this.error = {
            isError: true,
            errorMessage:
              'WARNING!!! Keywords cannot be searched. Enter the first 100 characters of the flash card.',
          };
        } else {
          this.error = { isError: false, errorMessage: '' };
        }
      } else {
        this.Descriptionvaluelength = 0;
        this.error = { isError: false, errorMessage: '' };
      }
    } else {
      this.Descriptionvaluelength = 0;
      this.error = { isError: false, errorMessage: '' };
    }
  }
  OpenEditQuestion(data: any) {
    this.ActivityHisotrypopupflag = true;
    this.EditButton(data);
    this.NextButtonflag = false;
    //this.child.EditQuestion(data);
  }

  RightAnswer1: any;
  EmitAnswerChoiceDetails(data: any) {
    this.RightAnswer1 = data;
  }

  currentlist: any;
  EmitpreviewDetails(data: any) {
    this.previewdetail = data;
    this.currentlist = data;
  }

  //body

  redirectscreenname: string | null;
  REdirectPreview(data: any) {
    this.redirectscreenname = data.Screename;
    this.previewdetail.safehtmlStr = data.safehtmlStr;
    this.QuestionPreview();

    // if(this.EditQuestionBodyPopup){
    //   //this.AnswerChoiceQuestionBody();
    //   this.QuestionBody();
    // }
  }

  Questionrefreshpreview(data: any) {
    this.redirectscreenname = data.Screename;
    this.previewdetail.safehtmlStr = data.safehtmlStr;
  }

  redirect: boolean = false;
  SelectedAnswer: any;
  AnswerIndicator: string;
  AddREdirecttoRightAnswer(data: any) {
    let Templist = {
      Answer_Choice_ID: null,
      Question_ID: this.selectedQuestionById[0].Question_ID,
      Question_Status_ID: this.selectedQuestionById[0].Question_Status_ID,
    };
    if (this.RightAnswer1 != null) {
      this.SelectedAnswer = this.RightAnswer1;
      this.AnswerIndicator = 'R';
    } else {
      this.SelectedAnswer = Templist;
    }
    let list = {
      QuestionById: this.SelectedAnswer,
      Answerflag1: this.AnswerIndicator,
    };

    this.ClickAnswerChoice(list);

    //this.AddQuestionpopup();
  }

  globalSubjectId: Array<IFlashcard>;
  closeTriggerValue: object | null = null;
  closeFaDialog(event?: any) {
    if (event) {
      this.flashCardModalRef?.close();

      this.RefreshActivity();
    }
    this.NextButtonflag = false;
    this.flashCardId = '';
    this.flashCardIdMatched = '';
    this.globalSubjectId = [];
    this.closeTriggerValue = null;
    this.flashcardService.updateNextButtonFlag(false);
  }

  closeEventTrigger() {
    this.closeTriggerValue = { hash: Date.now() } as unknown as object;
  }

  ActivityHPop = false;
  openActivityHistory() {
    console.log(this.selectedsubject);
    this.ActivityHPop = !this.ActivityHPop;
  }
  activityHistoryClose() {
    this.ActivityHPop = false;
  }

  openSelectedFlashCardEvent(evt: {
    FlashCard_ID: string;
    type: string;
    FlashcardList: Array<IFlashcard>;
  }) {
    this.Questionlistpopupflag = false;
    this.ActivityHPop = false;
    this.flashCardIdMatched = evt.FlashCard_ID;
    if (evt.type === 'history') {
      this.globalSubjectId = evt.FlashcardList;
    } else {
      this.globalSubjectId = evt.FlashcardList;
    }
    this.NextButtonflag = true;
  }

  flashCardId: string;
  flashCardIdMatched: string;
  getFlashCardId() {
    if (!this.flashCardId) {
      this.toastr.warning('Please Enter Flash Card ID...');
      return;
    }

    this.addEditFlashManagementService
      .getFlashcard({
        LoggedInUser: UserAuthDetails.getUserLoggedInId(),
        SessionLanguageTypeCode: null,
        SubjectID: null,
        FlashCardID: this.flashCardId,
        FromDate: null,
        ToDate: null,
        FlashCardStatus: null,
        FlashCardKeyword1: null,
        Operator: null,
        FlashCardKeyword2: null,
        OwnFlashCardInd: null,
        ScreenName: 'ASSIGN_FLASHCARD_TO_COURSE',
      })
      .subscribe((elem) => {
        this.flashCardIdMatched = elem.FlashCard_ID;
        this.NextButtonflag = true;
      });
  }
}
interface MajorTopic {
  ChildNodeExistInd: string;
  Data: any;
  Display_Order: Number;
  ID: Number;
  Name: string;
  Parent_Id: Number;
  Status_Code: string;
  Subject_Level_Type_Code: string;
  Total_Count: number;
  WIP_Count: number;
  Submitted_Count: number;
  Under_Review_Count: number;
  Rework_Count: number;
  Approved_Count: number;
  defer_Count: number;
  Rejected_Count: number;
}
